export { taskSharedCrudMetaReducer } from './task-shared-crud.reducer';
export { taskSharedLifecycleMetaReducer } from './task-shared-lifecycle.reducer';
export { taskSharedSchedulingMetaReducer } from './task-shared-scheduling.reducer';
export { taskSharedDeadlineMetaReducer } from './task-shared-deadline.reducer';
export { projectSharedMetaReducer } from './project-shared.reducer';
export { tagSharedMetaReducer } from './tag-shared.reducer';
export { plannerSharedMetaReducer } from './planner-shared.reducer';
export { taskBatchUpdateMetaReducer } from './task-batch-update.reducer';
export { issueProviderSharedMetaReducer } from './issue-provider-shared.reducer';
export { taskRepeatCfgSharedMetaReducer } from './task-repeat-cfg-shared.reducer';
export { shortSyntaxSharedMetaReducer } from './short-syntax-shared.reducer';
export { lwwUpdateMetaReducer } from './lww-update.meta-reducer';
export {
  operationCaptureMetaReducer,
  setOperationCaptureService,
} from '../../../op-log/capture/operation-capture.meta-reducer';
